import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  const footerLinks = [
    { to: '/lodge-room', label: t('nav.lodgeRoom') },
    { to: '/villa', label: t('nav.villa') },
    { to: '/explore', label: t('nav.explorations') },
    { to: '/dining', label: t('nav.dining') },
    { to: '/community', label: t('nav.community') },
    { to: '/gallery', label: t('nav.gallery') },
    { to: '/getting-here', label: t('nav.gettingHere') },
    { to: '/contact', label: t('nav.contact') },
  ];

  return (
    <footer className="py-8 bg-white border-t border-black/10" data-testid="footer">
      <div className="container mx-auto px-6 md:px-12 max-w-[1400px]">
        {/* Site Navigation Links */}
        <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 mb-8" data-testid="footer-nav">
          {footerLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="text-black/60 text-xs uppercase tracking-[0.15em] hover:text-black transition-colors duration-300"
              data-testid={`footer-link-${link.to.slice(1)}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Follow Us + Social Icons */}
          <div className="flex items-center gap-4">
            <span className="text-black text-xs uppercase tracking-[0.15em]">
              Follow us
            </span>
            <a 
              href="https://www.instagram.com/hotelrespiro/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-black/60 hover:text-black transition-colors duration-300"
              data-testid="footer-instagram"
            >
              <Instagram size={18} />
            </a>
          </div>

          {/* Copyright */}
          <p className="text-black/40 text-xs text-center">
            {t('footer.rights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
